<template>
     <vs-dialog prevent-close v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
              Editar plan académico
          </h4>
        </template>
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="6">
                    <vs-input label="Clave" v-model="info.clave" placeholder="Clave">
                        <template #message-danger v-if="errorFields.includes('clave')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <vs-input label="Nombre" v-model="info.nombre" placeholder="Nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <vs-input label="Fecha de creación" type="date" v-model="info.fecha_creacion">
                        <template #message-danger v-if="errorFields.includes('fecha_creacion')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <vs-select label="Programa" filter placeholder="Seleccionar programa" :key="programaId" v-model="info.programa_id" :disabled="!programas.length">
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postEditarPlan()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'programa',
      'planesEstudio',
      'programas'
    ],
    data () {
        return {
            active: false,
            info: [],
            errorFields: [],
            programaId: (new Date()).getTime(),
        }
    },
    methods: { 
        getInfo(){
            if(this.planesEstudio){
                let {clave = '', nombre = '', fecha_creacion = '', programa_id = '', id = ''} = this.planesEstudio
                Object.assign(this.info = {clave, nombre, fecha_creacion, programa_id, id})
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.info.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.info.clave) {
                this.errorFields.push('clave')
            }
            if (!this.info.fecha_creacion) {
                this.errorFields.push('fecha_creacion')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postEditarPlan(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    const params = {
                        clave: this.info.clave,
                        fecha_creacion: this.info.fecha_creacion,
                        nombre: this.info.nombre,
                        programa_id: this.info.programa_id
                    }
                    const formData = new FormData()
                    formData.append("clave", this.info.clave)
                    formData.append("fecha_creacion", this.info.fecha_creacion)
                    formData.append("nombre", this.info.nombre)
                    formData.append("programa_id", this.info.programa_id)
                    const response = await academico.postEditarPlan(this.info.id, params)
                    console.log(response.data)
                    loading.close()
                    this.active = false
                    this.$vs.notification({
                        sticky: true,
                        color: 'success',
                        position: null,
                        title: 'Se ha editado con éxito el plan de estudios'
                    })
                    this.$emit('refreshTable', this.info.programa_id)
                } catch (error) {
                    console.error(error)
                    loading.close()
                    this.$vs.notification({
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal, favor de contactar al administrador'
                    })
                }
            }
        },
     },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        planesEstudio(){
            this.getInfo()
        }
    }
}
</script>
<style scoped>
label{
    font-size: 0.75rem;
}
</style>